module.exports = __webpack_public_path__ + "img/1.17713d30.gif";